"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import { jsx, jsxs } from "react/jsx-runtime";
import s from "underscore.string";
import React from "react";
import _ from "underscore";
import PaymentAddressEditor from "../payment_address_editor";
import FactoringCompanyOfficePicker from "./factoring_company_office_picker";
import Account from "../../api/account";
import Address from "./address";
import get from "../data/get";
import Api from "../../api/api";
import WaitingSpinner from "../../components/waiting_spinner";
import DisablingButton from "../../components/disabling_button";
function carrierAddress(props) {
  if (props.carrier.payment_strategy == "direct") {
    return props.carrier.payment_address;
  }
}
function selectedAddress(props, state) {
  if (state.factoringCompanyOffice) {
    var address = get.paymentAddress(state.factoringCompanyOffice);
    var line_2 = address.address_line_2 || "";
    if (!s.isBlank(line_2)) {
      line_2 = line_2 + " ";
    }
    line_2 = line_2 + "FBO " + props.carrier.name;
    var carrierAddress2 = _.extend(_.clone(address), {
      address_line_2: line_2
    });
    return /* @__PURE__ */ jsx(Address, { source: carrierAddress2 });
  }
}
function saveFactorDisabledText(state) {
  return isInvalid(state) ? "Choose a Factoring Company Office" : "Saving...";
}
function isSaveFactorDisabled(state) {
  return state.isSavingFactor || isInvalid(state);
}
function isInvalid(state) {
  return _.isNull(state.factoringCompanyOffice);
}
function saveAddress(props, address) {
  return props.onSave("direct", address);
}
export default class extends React.Component {
  constructor() {
    super(...arguments);
    __publicField(this, "state", {
      paymentStrategy: this.props.carrier.payment_strategy,
      factoringCompanyOffice: null,
      isSavingFactor: false,
      isLoading: this.props.carrier.payment_strategy === "factor"
    });
    __publicField(this, "choose", (paymentStrategy) => {
      this.setState({
        paymentStrategy
      });
    });
    __publicField(this, "detail", () => {
      if (this.state.paymentStrategy === "direct") {
        return /* @__PURE__ */ jsx(
          PaymentAddressEditor,
          {
            address: carrierAddress(this.props),
            saveAddress: (address) => saveAddress(this.props, address),
            accountSettings: Account.currentSettings()
          }
        );
      } else {
        return /* @__PURE__ */ jsxs("div", { children: [
          /* @__PURE__ */ jsx(
            FactoringCompanyOfficePicker,
            {
              factoringCompanyOffice: this.state.factoringCompanyOffice,
              onSelect: this.factoringCompanyOfficeSelected,
              onClear: this.factoringCompanyOfficeCleared
            }
          ),
          selectedAddress(this.props, this.state),
          /* @__PURE__ */ jsx("div", { children: "\xA0" }),
          /* @__PURE__ */ jsx(
            DisablingButton,
            {
              className: "expand button--confirmation",
              onClick: this.saveFactor,
              disabledText: saveFactorDisabledText(this.state),
              disabled: isSaveFactorDisabled(this.state),
              children: "Save Address"
            }
          )
        ] });
      }
    });
    __publicField(this, "factoringCompanyOfficeCleared", () => {
      this.setState({
        factoringCompanyOffice: null
      });
    });
    __publicField(this, "factoringCompanyOfficeSelected", (factoringCompanyOffice) => {
      this.setState({
        factoringCompanyOffice
      });
    });
    __publicField(this, "saveFactor", () => {
      if (this.state.factoringCompanyOffice) {
        this.setState({ isSavingFactor: true });
        this.props.onSave("factor", this.state.factoringCompanyOffice).then(
          (arg) => {
            this.setState({ isSavingFactor: false });
            return arg;
          },
          (arg) => {
            this.setState({ isSavingFactor: false });
            return arg;
          }
        );
      }
    });
  }
  componentDidMount() {
    if (this.state.paymentStrategy === "factor") {
      Api.FactoringAssignments.index(this.props.carrier.id).then((x) => {
        this.setState({
          isLoading: false,
          factoringCompanyOffice: get.factoringCompanyOffice(
            this.props.carrier
          )
        });
      });
    }
  }
  render() {
    return /* @__PURE__ */ jsx(WaitingSpinner, { when: this.state.isLoading, children: /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsxs("label", { children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            type: "radio",
            name: "payment_strategy",
            checked: this.state.paymentStrategy === "direct",
            onChange: _.partial(this.choose, "direct")
          }
        ),
        "\xA0Direct to ",
        Account.carrierTerm()
      ] }),
      /* @__PURE__ */ jsxs("label", { children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            type: "radio",
            name: "payment_strategy",
            checked: this.state.paymentStrategy === "factor",
            onChange: _.partial(this.choose, "factor")
          }
        ),
        "\xA0Via Factor"
      ] }),
      this.detail()
    ] }) });
  }
}
